import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import HomePage from "./components/HomePage";
import WorkPage from "./components/WorkPage";
import AboutPage from "./components/AboutPage";
import StorefrontPage from "./components/StorefrontPage";
import TechStackPage from "./components/TechStackPage";
import ProgramsPage from "./components/ProgramsPage";
import LiftingForTwoPage from "./components/LiftingForTwoPage";
import Nav from "./components/Nav";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    return (
        <Router>
            <div className="flex flex-col min-h-[100dvh] bg-cream">
                <ScrollToTop />
                <Nav />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/work" element={<WorkPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/storefront" element={<StorefrontPage />} />
                    <Route path="/stack" element={<TechStackPage />} />
                    <Route path="/programs" element={<ProgramsPage />} />
                    <Route path="/programs/lifting-for-two" element={<LiftingForTwoPage />} />
                    {/* legacy redirects */}
                    <Route path="/products" element={<StorefrontPage />} />
                    <Route path="/health" element={<StorefrontPage />} />
                    <Route path="/engineer" element={<HomePage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
